import React from 'react';

import Column from '@amzn/meridian/column';
import Row from '@amzn/meridian/row';
import Text from '@amzn/meridian/text';
import { type BackgroundFormData } from 'src/store/newJmrPageSlice/types';

import CaseSourceOption from './caseSourceOption';

interface AssociateInformationProps {
  handleChange: (key: keyof BackgroundFormData, value: any) => void;
  isNewJMR: boolean;
}

const CaseSource = ({ handleChange, isNewJMR }: AssociateInformationProps) => {
  return (
    <Row className="new-jmr__background-page__caseSource-row">
      <Column spacing="200">
        <Text tag="label" type="b300" color="primary">
          Case Source
        </Text>
        <CaseSourceOption handleChange={handleChange} isNewJMR={isNewJMR}></CaseSourceOption>
      </Column>
    </Row>
  );
};

export default CaseSource;
